document.addEventListener('DOMContentLoaded', function () {
  var config = window.CrossSellConfig || {};

  if (!config.enabled) {
    return;
  }

  var root = document.getElementById('cross-sell-root');
  var modal = document.getElementById('cross-sell-modal');
  var overlay = document.getElementById('cross-sell-overlay');
  var closeButton = document.getElementById('cross-sell-close');

  var eyebrow = document.getElementById('cross-sell-eyebrow');
  var title = document.getElementById('cross-sell-title');
  var text = document.getElementById('cross-sell-text');
  var discountBadge = document.getElementById('cross-sell-discount-badge');
  var carouselTitle = document.getElementById('cross-sell-carousel-title');
  var carousel = document.getElementById('cross-sell-carousel');
  var viewAllButton = document.getElementById('cross-sell-view-all-button');
  var secondaryButton = document.getElementById('cross-sell-secondary-button');

  var pill = document.getElementById('cross-sell-pill');
  var pillText = document.getElementById('cross-sell-pill-text');
  var pillButton = document.getElementById('cross-sell-pill-button');

  if (!root || !modal || !overlay || !closeButton || !carousel || !pill) {
    console.warn('[Cross Sell] No se encontró la estructura base del módulo.');
    return;
  }

  var STORAGE_KEYS = {
    modalShown: 'cross-sell-modal-shown',
    benefitActive: 'cross-sell-benefit-active'
  };

  var state = {
    isOpen: false,
    lastOpenedAt: 0,
    cooldownMs: 1400,
    motionTimer: null,
    addTriggeredThisSession: sessionStorage.getItem(STORAGE_KEYS.modalShown) === 'true',
    benefitActive: sessionStorage.getItem(STORAGE_KEYS.benefitActive) === 'true',
    openingLock: false,
    openingLockTimer: null,
    productTagCache: {},
    suggestedProductsCache: null,
    suggestedProductsPromise: null,
    isAddingSuggestedProduct: false
  };

  function debugLog() {
    if (config.debug) {
      console.log.apply(console, arguments);
    }
  }

  function normalizeTag(value) {
    return String(value || '').trim().toLowerCase();
  }

  function hasTag(tags, targetTag) {
    var normalizedTarget = normalizeTag(targetTag);

    if (!normalizedTarget || !Array.isArray(tags)) {
      return false;
    }

    for (var i = 0; i < tags.length; i += 1) {
      if (normalizeTag(tags[i]) === normalizedTarget) {
        return true;
      }
    }

    return false;
  }

  function normalizeMoneyValue(value) {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    var raw = String(value).replace(/[^0-9.-]/g, '');
    var numberValue = Number(raw);

    if (!isFinite(numberValue)) {
      return 0;
    }

    if (Math.abs(numberValue) >= 1000 && String(raw).indexOf('.') === -1) {
      return numberValue / 100;
    }

    return numberValue;
  }

  function formatMoney(value) {
    if (typeof value !== 'number' || !isFinite(value)) {
      return '$0.00 MXN';
    }

    return '$' + value.toFixed(2) + ' MXN';
  }

  function applyDiscount(price, percent) {
    var numericPrice = Number(price);
    var numericPercent = Number(percent);

    if (!isFinite(numericPrice)) {
      return 0;
    }

    if (!isFinite(numericPercent) || numericPercent <= 0) {
      return numericPrice;
    }

    return numericPrice * (1 - (numericPercent / 100));
  }

  function escapeHtml(value) {
    if (typeof value !== 'string') {
      return '';
    }

    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getViewAllUrl() {
    return typeof config.viewAllUrl === 'string' && config.viewAllUrl.trim() !== ''
      ? config.viewAllUrl
      : '#';
  }

  function getProductsLimit() {
    var limit = Number(config.productsLimit);

    if (!isFinite(limit) || limit <= 0) {
      return 5;
    }

    return Math.min(Math.floor(limit), 8);
  }

  function setBenefitActive(active) {
    state.benefitActive = active;

    if (active) {
      sessionStorage.setItem(STORAGE_KEYS.benefitActive, 'true');
    } else {
      sessionStorage.removeItem(STORAGE_KEYS.benefitActive);
    }

    syncPillState();
  }

  function markModalShown() {
    state.addTriggeredThisSession = true;
    sessionStorage.setItem(STORAGE_KEYS.modalShown, 'true');
  }

  function setOpeningLock() {
    state.openingLock = true;

    if (state.openingLockTimer) {
      clearTimeout(state.openingLockTimer);
    }

    state.openingLockTimer = setTimeout(function () {
      state.openingLock = false;
      state.openingLockTimer = null;
    }, 1200);
  }

  function shuffleArray(items) {
    var arr = items.slice();

    for (var i = arr.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = arr[i];
      arr[i] = arr[j];
      arr[j] = temp;
    }

    return arr;
  }

  function resolveImageUrl(product) {
    if (!product) {
      return '';
    }

    if (typeof product.featured_image === 'string' && product.featured_image) {
      return product.featured_image;
    }

    if (product.featured_image && typeof product.featured_image.src === 'string' && product.featured_image.src) {
      return product.featured_image.src;
    }

    if (product.image && typeof product.image.src === 'string' && product.image.src) {
      return product.image.src;
    }

    if (typeof product.image === 'string' && product.image) {
      return product.image;
    }

    if (Array.isArray(product.images) && product.images.length) {
      var firstImage = product.images[0];

      if (typeof firstImage === 'string' && firstImage) {
        return firstImage;
      }

      if (firstImage && typeof firstImage.src === 'string' && firstImage.src) {
        return firstImage.src;
      }
    }

    return '';
  }

  function getFirstAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) {
      return null;
    }

    for (var i = 0; i < product.variants.length; i += 1) {
      if (product.variants[i] && product.variants[i].available) {
        return product.variants[i];
      }
    }

    return null;
  }

  function buildProductCard(product, index) {
    var item = document.createElement('article');
    item.className = 'cross-sell-item';
    item.setAttribute('data-cross-sell-index', String(index));

    var imageHtml = '';
    var originalPriceHtml = '';

    if (product.image) {
      imageHtml =
        '<img class="cross-sell-item-image" src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '">';
    }

    if (typeof product.originalPrice === 'number' && isFinite(product.originalPrice) && product.originalPrice > 0) {
      originalPriceHtml = '<p class="cross-sell-item-compare">' + formatMoney(product.originalPrice) + '</p>';
    }

    item.innerHTML =
      '<div class="cross-sell-item-media">' +
        imageHtml +
      '</div>' +
      '<div class="cross-sell-item-body">' +
        '<p class="cross-sell-item-label">' + escapeHtml(product.label || 'Accesorios TCG') + '</p>' +
        '<h3 class="cross-sell-item-title">' + escapeHtml(product.title) + '</h3>' +
        '<div class="cross-sell-item-price-wrap">' +
          originalPriceHtml +
          '<p class="cross-sell-item-price">' + formatMoney(product.finalPrice) + '</p>' +
        '</div>' +
      '</div>' +
      '<button ' +
        'type="button" ' +
        'class="cross-sell-item-button" ' +
        'data-cross-sell-add-id="' + escapeHtml(String(product.variantId || '')) + '" ' +
        'data-cross-sell-product-url="' + escapeHtml(product.url || '') + '"' +
      '>' +
        'Añadir' +
      '</button>';

    return item;
  }

  function buildMoreCard() {
    var item = document.createElement('article');
    item.className = 'cross-sell-item--more';

    item.innerHTML =
      '<div class="cross-sell-item-more-top">' +
        '<p class="cross-sell-item-more-badge">Más opciones</p>' +
        '<h3 class="cross-sell-item-more-title">Ver más productos con descuento</h3>' +
        '<p class="cross-sell-item-more-text">Explora más artículos elegibles y aprovecha el beneficio activo.</p>' +
      '</div>' +
      '<button type="button" class="cross-sell-item-more-button" data-cross-sell-view-all="true">' +
        'Ver más' +
      '</button>';

    return item;
  }

  function renderCarousel(products) {
    carousel.innerHTML = '';

    products.slice(0, getProductsLimit()).forEach(function (product, index) {
      carousel.appendChild(buildProductCard(product, index));
    });

    carousel.appendChild(buildMoreCard());
  }

  function setModalContent(data) {
    if (eyebrow && typeof data.eyebrow === 'string') {
      eyebrow.textContent = data.eyebrow;
    }

    if (title && typeof data.title === 'string') {
      title.textContent = data.title;
    }

    if (text && typeof data.text === 'string') {
      text.textContent = data.text;
    }

    if (discountBadge && typeof data.discountBadge === 'string') {
      discountBadge.textContent = data.discountBadge;
    }

    if (carouselTitle && typeof data.carouselTitle === 'string') {
      carouselTitle.textContent = data.carouselTitle;
    }

    if (viewAllButton && typeof data.viewAllButtonText === 'string') {
      viewAllButton.textContent = data.viewAllButtonText;
    }

    if (secondaryButton && typeof data.secondaryButtonText === 'string') {
      secondaryButton.textContent = data.secondaryButtonText;
    }

    if (pillText && typeof data.pillText === 'string') {
      pillText.textContent = data.pillText;
    }

    if (Array.isArray(data.products)) {
      renderCarousel(data.products);
    }
  }

  function openModal(data) {
    setModalContent(data || {});
    root.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cross-sell-open');
    state.isOpen = true;
    state.lastOpenedAt = Date.now();
    syncPillState();
  }

  function closeModal() {
    root.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cross-sell-open');
    state.isOpen = false;
    syncPillState();
  }

  function syncPillState() {
    if (!state.benefitActive || state.isOpen) {
      pill.hidden = true;
      return;
    }

    pill.hidden = false;
  }

  function hidePillByMotion() {
    if (pill.hidden) {
      return;
    }

    pill.classList.add('is-hidden-by-motion');

    clearTimeout(state.motionTimer);
    state.motionTimer = setTimeout(function () {
      pill.classList.remove('is-hidden-by-motion');
    }, 220);
  }

  function navigateToViewAll() {
    var url = getViewAllUrl();

    if (!url || url === '#') {
      alert('Define la URL real en cross-sell-config.liquid para abrir todos los productos con descuento.');
      return;
    }

    window.location.href = url;
  }

  function getDiscountPercent() {
    var discount = Number(config.discountPercent);
    return isFinite(discount) ? discount : 10;
  }

  function getFallbackProducts() {
    var url = getViewAllUrl();
    var discountPercent = getDiscountPercent();

    function makeProduct(titleValue, originalPrice) {
      return {
        title: titleValue,
        originalPrice: originalPrice,
        finalPrice: applyDiscount(originalPrice, discountPercent),
        label: 'Accesorios TCG',
        image: '',
        url: url,
        variantId: ''
      };
    }

    return [
      makeProduct('Mica premium de prueba', 89.00),
      makeProduct('Portamazo rígido de prueba', 149.00),
      makeProduct('Deck box de prueba', 129.00),
      makeProduct('Sleeves especiales de prueba', 99.00),
      makeProduct('Portafolio para cartas de prueba', 219.00)
    ];
  }

  function getBaseModalData(products) {
    var discountPercent = getDiscountPercent();

    return {
      eyebrow: 'Beneficio especial',
      title: '¡Aprovecha tu envío!',
      text: 'Tu carrito contiene al menos un producto TCG. Obtén:',
      discountBadge: discountPercent + '% de descuento en productos seleccionados',
      carouselTitle: 'Algunos accesorios:',
      viewAllButtonText: 'Ver más accesorios',
      secondaryButtonText: 'No, gracias',
      pillText: 'Tienes activo un ' + discountPercent + '% de descuento en productos seleccionados',
      products: Array.isArray(products) && products.length ? products : getFallbackProducts()
    };
  }

  function canOpenByEvent() {
    var now = Date.now();

    if (state.isOpen) {
      return false;
    }

    if (state.openingLock) {
      return false;
    }

    if (now - state.lastOpenedAt < state.cooldownMs) {
      return false;
    }

    if (config.showModalOncePerSession !== false && state.addTriggeredThisSession) {
      return false;
    }

    return true;
  }

  function triggerQualifiedAdd(source) {
    if (!canOpenByEvent()) {
      debugLog('[Cross Sell] Evento ignorado (' + source + ') por sesión/cooldown/lock.');
      return;
    }

    debugLog('[Cross Sell] Apertura permitida desde:', source);

    setOpeningLock();
    setBenefitActive(true);
    markModalShown();

    loadSuggestedProducts().then(function (products) {
      openModal(getBaseModalData(products));
    }).catch(function (error) {
      console.warn('[Cross Sell] No se pudieron cargar productos reales. Se usará fallback.', error);
      openModal(getBaseModalData(getFallbackProducts()));
    });
  }

  function getCartJson() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('No se pudo leer /cart.js');
      }

      return response.json();
    });
  }

  function getProductJsonByHandle(handle) {
    if (!handle) {
      return Promise.resolve(null);
    }

    if (state.productTagCache[handle]) {
      return Promise.resolve(state.productTagCache[handle]);
    }

    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('No se pudo leer el producto: ' + handle);
      }

      return response.json();
    }).then(function (product) {
      state.productTagCache[handle] = product;
      return product;
    });
  }

  function extractHandleFromCartItem(item) {
    if (!item) {
      return '';
    }

    if (typeof item.handle === 'string' && item.handle) {
      return item.handle;
    }

    if (typeof item.url === 'string' && item.url) {
      var match = item.url.match(/\/products\/([^/?#]+)/i);

      if (match && match[1]) {
        return match[1];
      }
    }

    return '';
  }

  function cartContainsTriggerTag() {
    var triggerTag = config.triggerTag || '';

    if (!triggerTag) {
      debugLog('[Cross Sell] No se definió triggerTag.');
      return Promise.resolve(false);
    }

    return getCartJson().then(function (cart) {
      var items = Array.isArray(cart && cart.items) ? cart.items : [];

      if (!items.length) {
        debugLog('[Cross Sell] El carrito está vacío.');
        return false;
      }

      var uniqueHandles = [];
      var seen = {};

      items.forEach(function (item) {
        var itemHandle = extractHandleFromCartItem(item);

        if (itemHandle && !seen[itemHandle]) {
          seen[itemHandle] = true;
          uniqueHandles.push(itemHandle);
        }
      });

      if (!uniqueHandles.length) {
        debugLog('[Cross Sell] No se encontraron handles para validar tags.');
        return false;
      }

      return Promise.all(
        uniqueHandles.map(function (handle) {
          return getProductJsonByHandle(handle).catch(function (error) {
            console.warn('[Cross Sell] No se pudo leer tags del producto:', handle, error);
            return null;
          });
        })
      ).then(function (products) {
        for (var i = 0; i < products.length; i += 1) {
          var product = products[i];

          if (!product) {
            continue;
          }

          if (hasTag(product.tags, triggerTag)) {
            debugLog('[Cross Sell] Trigger tag detectado en producto:', product.handle, triggerTag);
            return true;
          }
        }

        debugLog('[Cross Sell] El carrito no contiene productos con trigger tag:', triggerTag);
        return false;
      });
    }).catch(function (error) {
      console.warn('[Cross Sell] Error evaluando carrito para trigger:', error);
      return false;
    });
  }

  function getCollectionProducts() {
    var collectionHandle = String(config.targetCollectionHandle || '').trim();

    if (!collectionHandle) {
      return Promise.reject(new Error('No se definió targetCollectionHandle'));
    }

    return fetch('/collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=250', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('No se pudo leer la colección: ' + collectionHandle);
      }

      return response.json();
    }).then(function (data) {
      return Array.isArray(data && data.products) ? data.products : [];
    });
  }

  function mapCollectionProduct(product) {
    if (!product) {
      return null;
    }

    var variant = getFirstAvailableVariant(product);

    if (!variant) {
      return null;
    }

    var imageUrl = resolveImageUrl(product);
    var originalPrice = normalizeMoneyValue(variant.price);
    var finalPrice = applyDiscount(originalPrice, getDiscountPercent());

    if (!isFinite(originalPrice) || originalPrice <= 0) {
      return null;
    }

    return {
      title: String(product.title || 'Producto'),
      originalPrice: originalPrice,
      finalPrice: finalPrice,
      label: config.suggestedTag || 'Accesorios TCG',
      image: imageUrl,
      url: '/products/' + encodeURIComponent(product.handle),
      variantId: variant.id ? String(variant.id) : ''
    };
  }

  function loadSuggestedProducts() {
    if (Array.isArray(state.suggestedProductsCache)) {
      return Promise.resolve(shuffleArray(state.suggestedProductsCache).slice(0, getProductsLimit()));
    }

    if (state.suggestedProductsPromise) {
      return state.suggestedProductsPromise.then(function (products) {
        return shuffleArray(products).slice(0, getProductsLimit());
      });
    }

    state.suggestedProductsPromise = getCollectionProducts().then(function (products) {
      var suggestedTag = config.suggestedTag || '';

      var filtered = products.filter(function (product) {
        return hasTag(product.tags, suggestedTag) && !!getFirstAvailableVariant(product);
      });

      var mapped = filtered
        .map(mapCollectionProduct)
        .filter(function (item) {
          return !!item && !!item.variantId;
        });

      if (!mapped.length) {
        throw new Error('No se encontraron productos con stock y tag sugerido dentro de la colección.');
      }

      state.suggestedProductsCache = mapped;
      return mapped;
    }).finally(function () {
      state.suggestedProductsPromise = null;
    });

    return state.suggestedProductsPromise.then(function (products) {
      return shuffleArray(products).slice(0, getProductsLimit());
    });
  }

  function refreshCartUiAfterAdd() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    try {
      window.dispatchEvent(new Event('cart:refresh'));
      window.dispatchEvent(new Event('cart:updated'));
    } catch (error) {
      debugLog('[Cross Sell] No se pudieron emitir algunos eventos de refresh del carrito.', error);
    }
  }

  function addSuggestedProductToCart(variantId, button) {
    if (state.isAddingSuggestedProduct) {
      return;
    }

    state.isAddingSuggestedProduct = true;

    var originalText = button ? button.textContent : '';
    var productUrl = button ? button.getAttribute('data-cross-sell-product-url') || '' : '';

    if (button) {
      button.disabled = true;
      button.textContent = 'Añadiendo...';
    }

    function extractHandleFromProductUrl(url) {
      if (!url || typeof url !== 'string') {
        return '';
      }

      var match = url.match(/\/products\/([^/?#]+)/i);
      return match && match[1] ? match[1] : '';
    }

    function postAjaxAdd(resolvedVariantId) {
      var formData = new FormData();
      formData.append('id', String(resolvedVariantId));
      formData.append('quantity', '1');

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      }).then(function (response) {
        if (!response.ok) {
          return response.text().then(function (errorText) {
            console.error('[Cross Sell] Shopify rechazó /cart/add.js. VariantId:', resolvedVariantId);
            console.error('[Cross Sell] Respuesta 422/error:', errorText);
            throw new Error(errorText || 'Shopify devolvió un error al añadir el producto.');
          });
        }

        return response.json();
      });
    }

    function resolveFreshVariantId() {
      var handle = extractHandleFromProductUrl(productUrl);

      if (!handle) {
        console.warn('[Cross Sell] No se pudo extraer handle del productUrl. Se usará el variantId original:', variantId);
        return Promise.resolve(String(variantId || ''));
      }

      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('No se pudo consultar el producto para obtener una variante fresca.');
        }

        return response.json();
      }).then(function (product) {
        if (!product || !Array.isArray(product.variants) || !product.variants.length) {
          throw new Error('El producto no contiene variantes.');
        }

        var freshVariant = null;

        for (var i = 0; i < product.variants.length; i += 1) {
          if (product.variants[i] && product.variants[i].available) {
            freshVariant = product.variants[i];
            break;
          }
        }

        if (!freshVariant || !freshVariant.id) {
          throw new Error('No se encontró una variante disponible.');
        }

        console.log('[Cross Sell] VariantId original:', variantId);
        console.log('[Cross Sell] VariantId fresco:', freshVariant.id);
        console.log('[Cross Sell] Producto consultado:', handle);

        return String(freshVariant.id);
      }).catch(function (error) {
        console.warn('[Cross Sell] Falló la resolución de variante fresca. Se usará el variantId original.', error);
        return String(variantId || '');
      });
    }

    function fallbackNativeAdd(resolvedVariantId) {
      console.warn('[Cross Sell] Ejecutando fallback nativo a /cart/add con variantId:', resolvedVariantId);

      var form = document.createElement('form');
      form.method = 'POST';
      form.action = '/cart/add';
      form.style.display = 'none';

      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = String(resolvedVariantId);

      var qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';

      form.appendChild(idInput);
      form.appendChild(qtyInput);
      document.body.appendChild(form);
      form.submit();
    }

    resolveFreshVariantId().then(function (resolvedVariantId) {
      if (!resolvedVariantId) {
        throw new Error('No existe variantId resoluble para este producto.');
      }

      return postAjaxAdd(resolvedVariantId).then(function (addedItem) {
        return {
          addedItem: addedItem,
          resolvedVariantId: resolvedVariantId
        };
      });
    }).then(function (result) {
      console.log('[Cross Sell] Producto añadido correctamente vía AJAX:', result.addedItem);

      if (button) {
        button.textContent = 'Añadido';
      }

      refreshCartUiAfterAdd();

      setTimeout(function () {
        closeModal();
      }, 500);
    }).catch(function (error) {
      console.warn('[Cross Sell] AJAX add falló. Se intentará fallback nativo.', error);

      resolveFreshVariantId().then(function (resolvedVariantId) {
        fallbackNativeAdd(resolvedVariantId);
      }).catch(function () {
        if (button) {
          button.disabled = false;
          button.textContent = originalText || 'Añadir';
        }

        if (productUrl) {
          window.location.href = productUrl;
        }
      });
    }).finally(function () {
      state.isAddingSuggestedProduct = false;

      if (button && button.textContent !== 'Añadido') {
        button.disabled = false;
      }
    });
  }

  function attemptTriggerFromSource(source) {
    if (state.isAddingSuggestedProduct) {
      debugLog('[Cross Sell] Trigger ignorado porque el add proviene del modal.');
      return;
    }

    cartContainsTriggerTag().then(function (shouldOpen) {
      if (!shouldOpen) {
        debugLog('[Cross Sell] No se abre modal desde ' + source + ' porque el carrito no contiene TCG.');
        return;
      }

      triggerQualifiedAdd(source);
    });
  }

  overlay.addEventListener('click', closeModal);
  closeButton.addEventListener('click', closeModal);

  if (secondaryButton) {
    secondaryButton.addEventListener('click', closeModal);
  }

  if (viewAllButton) {
    viewAllButton.addEventListener('click', navigateToViewAll);
  }

  if (pillButton) {
    pillButton.addEventListener('click', navigateToViewAll);
  }

  carousel.addEventListener('click', function (event) {
    var addButton = event.target.closest('[data-cross-sell-add-id]');
    var viewMoreButton = event.target.closest('[data-cross-sell-view-all]');

    if (viewMoreButton) {
      navigateToViewAll();
      return;
    }

    if (!addButton) {
      return;
    }

    var variantId = addButton.getAttribute('data-cross-sell-add-id') || '';
    addSuggestedProductToCart(variantId, addButton);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !root.hidden) {
      closeModal();
    }
  });

  window.addEventListener('scroll', hidePillByMotion, { passive: true });
  window.addEventListener('touchmove', hidePillByMotion, { passive: true });
  window.addEventListener('wheel', hidePillByMotion, { passive: true });

  window.CrossSellTest = {
    open: function () {
      setBenefitActive(true);
      markModalShown();
      setOpeningLock();

      loadSuggestedProducts().then(function (products) {
        openModal(getBaseModalData(products));
      }).catch(function () {
        openModal(getBaseModalData(getFallbackProducts()));
      });
    },
    close: closeModal,
    showPill: function () {
      setBenefitActive(true);
    },
    hidePill: function () {
      setBenefitActive(false);
    },
    resetSession: function () {
      sessionStorage.removeItem(STORAGE_KEYS.modalShown);
      sessionStorage.removeItem(STORAGE_KEYS.benefitActive);
      state.addTriggeredThisSession = false;
      state.benefitActive = false;
      state.openingLock = false;

      if (state.openingLockTimer) {
        clearTimeout(state.openingLockTimer);
        state.openingLockTimer = null;
      }

      closeModal();
      syncPillState();
    }
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    var action = form.getAttribute('action') || '';

    if (!action.includes('/cart/add')) {
      return;
    }

    debugLog('[Cross Sell] Submit de add-to-cart detectado.');

    setTimeout(function () {
      attemptTriggerFromSource('submit');
    }, 900);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      'button[name="add"], [data-action="add-to-cart"], button[type="submit"]'
    );

    if (!button) {
      return;
    }

    if (button.closest('#cross-sell-root')) {
      return;
    }

    debugLog('[Cross Sell] Click add-to-cart detectado.');

    setTimeout(function () {
      attemptTriggerFromSource('click');
    }, 500);
  }, true);

  (function () {
    var originalFetch = window.fetch;

    if (typeof originalFetch !== 'function') {
      return;
    }

    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var requestUrl = args[0];

      return originalFetch.apply(this, args).then(function (response) {
        try {
          var url = '';

          if (typeof requestUrl === 'string') {
            url = requestUrl;
          } else if (requestUrl && typeof requestUrl.url === 'string') {
            url = requestUrl.url;
          }

          if (
            url.includes('/cart/add') ||
            url.includes('/cart/add.js') ||
            url.includes('/cart/update')
          ) {
            setTimeout(function () {
              debugLog('[Cross Sell] Add detectado vía fetch:', url, response && response.status);
              attemptTriggerFromSource('fetch');
            }, 250);
          }
        } catch (error) {
          console.warn('[Cross Sell] Error interceptando fetch:', error);
        }

        return response;
      }).catch(function (error) {
        console.warn('[Cross Sell] Fetch de add-to-cart falló:', error);
        throw error;
      });
    };
  })();

  syncPillState();
  debugLog('[Cross Sell] Modal + pill listos.', config);
});